export const isInWishlist = (item: any) => {
  if (!window._swat) {
    throw new Error('Swat is not initialized')
  }

  return new Promise((resolve, reject) => {
    window._swat.fetch((res: any) => {
      // console.log("res", res);
      // console.log("item", item);
      
      if (res.length === 0) reject(false)

      // check if item.id matches any of the res.epi
      const isRes = res.some((r: any) => r.epi === item.id )

      if (isRes) resolve(true)
      resolve(false)
    })
  })
}